var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDispatchedFormGeolocated = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 19,
  height: 22,
  viewBox: "0 0 19 22"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "dispatched-form-geolocated_svg__a",
  d: "M0 8.8C0 14.675 7.121 22 9.263 22c2.143 0 9.263-7.325 9.263-13.2 0-4.86-4.146-8.8-9.263-8.8C4.148 0 0 3.94 0 8.8m4.632 0c0-2.43 2.073-4.4 4.631-4.4s4.632 1.97 4.632 4.4a4.3 4.3 0 0 1-1.357 3.112 4.76 4.76 0 0 1-3.275 1.289c-2.558 0-4.63-1.97-4.63-4.4"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "dispatched-form-geolocated_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dispatched-form-geolocated_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#434341",
  d: "M-4.632 27.79h28.948V-4.633H-4.632z",
  mask: "url(#dispatched-form-geolocated_svg__b)"
}))));
export default SvgDispatchedFormGeolocated;